import * as screenWidthConstants from '../constants/ScreenWidthConstants';
export const isScreenDesktopLarge = () => window.matchMedia(`(min-width: ${screenWidthConstants.MIN_SCREEN_WIDTH_DESKTOP_LARGE}px)`).matches;
export const isScreenDesktop = () => window.matchMedia(`(min-width: ${screenWidthConstants.MIN_SCREEN_WIDTH_DESKTOP}px)`).matches;
export const isScreenTablet = () => window.matchMedia(`(min-width: ${screenWidthConstants.MIN_SCREEN_WIDTH_TABLET}px)`).matches &&
    window.matchMedia(`(max-width: ${screenWidthConstants.MAX_SCREEN_WIDTH_TABLET}px)`).matches;
export const isScreenTabletSmall = () => window.matchMedia(`(min-width: ${screenWidthConstants.MIN_SCREEN_WIDTH_TABLET_SMALL}px)`).matches &&
    window.matchMedia(`(max-width: ${screenWidthConstants.MAX_SCREEN_WIDTH_TABLET_SMALL}px)`).matches;
export const isScreenMobileLarge = () => window.matchMedia(`(min-width: ${screenWidthConstants.MIN_SCREEN_WIDTH_MOBILE_LARGE}px)`).matches &&
    window.matchMedia(`(max-width: ${screenWidthConstants.MAX_SCREEN_WIDTH_MOBILE_LARGE}px)`).matches;
export const isScreenMobile = () => window.matchMedia(`(max-width: ${screenWidthConstants.MAX_SCREEN_WIDTH_MOBILE}px)`).matches;
export const getNbrOfItemsInListerRow = () => {
    if (isScreenDesktopLarge()) {
        return screenWidthConstants.NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP_LARGE;
    }
    else if (isScreenDesktop()) {
        return screenWidthConstants.NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP;
    }
    else if (isScreenTablet()) {
        return screenWidthConstants.NUMBER_OF_ITEMS_IN_LISTER_ROW_TABLET;
    }
    else if (isScreenTabletSmall()) {
        return screenWidthConstants.NUMBER_OF_ITEMS_IN_LISTER_ROW_TABLET_SMALL;
    }
    else if (isScreenMobileLarge()) {
        return screenWidthConstants.NUMBER_OF_ITEMS_IN_LISTER_ROW_MOBILE_LARGE;
    }
    else if (isScreenMobile()) {
        return screenWidthConstants.NUMBER_OF_ITEMS_IN_LISTER_ROW_MOBILE;
    }
    return screenWidthConstants.NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP;
};
export const isTouchScreen = () => typeof window !== 'undefined' && 'ontouchstart' in document.documentElement;
